export type SiteTemplateType =
  'TermsAndConditions'
  | 'PrivatePolicy'
  | 'ComplaintsPolicy'
  | 'InformationSheet'
  | 'PriceList'
  | 'CommonPepInfo';

export const SITE_TEMPLATES: SiteTemplateType[] = ['TermsAndConditions', 'PrivatePolicy', 'ComplaintsPolicy', 'InformationSheet', 'PriceList', 'CommonPepInfo'];
